import React from 'react'

export type ChevronUpIconProps = {
  color?: string
  className?: string
  width?: number
  height?: number
}

export const ChevronUpIcon = ({
  color = 'currentColor',
  className,
  width = 24,
  height = 24,
}: ChevronUpIconProps) => (
  <svg
    aria-label='Chevron up'
    className={className}
    fill='none'
    height={height}
    role='img'
    viewBox='0 0 24 24'
    width={width}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M19 16L12 8L5 16'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
  </svg>
)
